The partial position profile to list job categories for.

This should include the same field values that will eventually be used to create or post the `PositionProfile`.
